import { createSlice } from "@reduxjs/toolkit";

const campaignSlice = createSlice({
  name: "campaignSetter",
  initialState: {
    html:"",
    cc : [],
    bcc : [],
    isAdvisor: false,
    widgetType:"footer",
    campaignId: "",
    campaignName: "",
    campaignDescription: "",
    campaignType: "",
    campaignSubject: "",
    campaignAudienceName: "",
    campaignAudienceId: "",
    campaignEmail: "",
    campaignEditMode: false,
    campaignViewMode: false,
    campignTemplateId: null,
    campaignFlow: false,
    campaignABTestEnabled: false,
    campaignABTestChecked: false,
    backfromCampaign: false,
    isNewCampaignTempateId: false,
    complaiceStatus: "Pending",
    currentABTestCampaign: "A",
    campaignStatus: "",
    campaingABTestData: {
      campaignABTestId: "",
      campaignABTestVariation: "",
      campaignABTestPercentage: 10,
      campaignABTestWaitTime: 0.5,
      campaignABTestDecidingParameter: "",
      campaignABTestSubject: "",
      campaignABTestTemplateId: "",
    },
    isLoading: false,
    isLoadingClone: false,
    wordpressFlag: true,
    category: "",
    publishedUrl : "",
    scriptCode : '',
  },
  reducers: {
    setCampaignIsAdvisor: (state, action) => {
      state.isAdvisor = action.payload;
    },
    setCategory: (state, action) => {
      state.category = action.payload;
    },
    setCC : (state, action) => {
      state.cc = action.payload;
    },
    setBCC : (state, action) => {
      state.bcc = action.payload;
    },


    setwordpressFlag : (state, action) => {
      state.wordpressFlag = action.payload;
    },
    setCampaignWidget: (state, action) => {
      state.widgetType = action.payload;
    },
    setCampaignHtml: (state, action) => {
      state.html = action.payload;
    },
    setCampaignId: (state, action) => {
      state.campaignId = action.payload;
    },
    setCampaignName: (state, action) => {
      state.campaignName = action.payload;
    },
    setCampaignDescription: (state, action) => {
      state.campaignDescription = action.payload;
    },
    setCampaignType: (state, action) => {
      state.campaignType = action.payload;
    },
    setCampaignSubject: (state, action) => {
      state.campaignSubject = action.payload;
    },
    setCampaignAudienceName: (state, action) => {
      state.campaignAudienceName = action.payload;
    },
    setCampaignAudienceId: (state, action) => {
      state.campaignAudienceId = action.payload;
    },
    setCampaignEmail: (state, action) => {
      state.campaignEmail = action.payload;
    },
    setcampaignEditMode: (state, action) => {
      state.campaignEditMode = action.payload;
    },
    setCampaignViewMode: (state, action) => {
      state.campaignViewMode = action.payload;
    },
    setCampaignStatus: (state, action) => {
      state.campaignStatus = action.payload;
    },
    setCampignTemplateId: (state, action) => {
      state.campignTemplateId = action.payload;
    },
    setCampaignFlow: (state, action) => {
      state.campaignFlow = action.payload;
    },
    setBackfromCampaign: (state, action) => {
      state.backfromCampaign = action.payload;
    },
    setComplaiceStatus: (state, action) => {
      state.complaiceStatus = action.payload;
    },
    setisNewCampaignTempateId: (state, action) => {
      state.isNewCampaignTempateId = action.payload;
    },
    setCampaignABTestEnabled: (state, action) => {
      state.campaignABTestEnabled = action.payload;
    },
    setCampaignABTestChecked: (state, action) => {
      state.campaignABTestChecked = action.payload;
    },
    setCampaignABTestVariation: (state, action) => {
      state.campaingABTestData.campaignABTestVariation = action.payload;
    },
    setCampaignABTestPercentage: (state, action) => {
      state.campaingABTestData.campaignABTestPercentage = action.payload;
    },
    setCampaignABTestWaitTime: (state, action) => {
      state.campaingABTestData.campaignABTestWaitTime = action.payload;
    },
    setCampaignABTestId: (state, action) => {
      state.campaingABTestData.campaignABTestId = action.payload;
    },
    setCampaignABTestSubject: (state, action) => {
      state.campaingABTestData.campaignABTestSubject = action.payload;
    },
    setCampaignABTestTemplateId: (state, action) => {
      state.campaingABTestData.campaignABTestTemplateId = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsLoadingClone: (state, action) => {
      state.isLoadingClone = action.payload;
    },
    setCampaignABTestDecidingParameter: (state, action) => {
      state.campaingABTestData.campaignABTestDecidingParameter = action.payload;
    },
    setPublishedUrl: (state, action) => {
      state.publishedUrl = action.payload;
    },
    setscriptCode: (state, action) => {
      state.scriptCode = action.payload;
    },
    resetCampaignData: (state) => {
      state.category = "";
      state.isAdvisor = false;
      state.widgetType = 'footer'
      state.html="";
      state.cc = [];
      state.bcc = [];
      state.campaignId = "";
      state.campaignName = "";
      state.campaignDescription = "";
      state.campaignType = "";
   

      let role = localStorage.getItem("role") || sessionStorage.getItem("role") ;
      
      if (role === "publisher") {
        state.campaignType = "publishedContent";
      } else {
        state.campaignType = "";
      }


      state.publishedUrl = "";
      state.scriptCode = "";


      state.campaignSubject = "";
      state.campaignAudienceName = "";
      state.campaignAudienceId = "";
      state.campaignEmail = "";
      state.campaignEditMode = false;
      state.campaignViewMode = false;
      state.campignTemplateId = null;
      state.campaignFlow = false;
      state.backfromCampaign = false;
      state.campaignABTestEnabled = false;
      state.campaignABTestChecked = false;
      state.complaiceStatus = "Pending";
      state.isNewCampaignTempateId = false;
      state.currentABTestCampaign = "A";
      state.campaignStatus = "";
      state.campaingABTestData = {
        campaignABTestVariation: "",
        campaignABTestPercentage: 0,
        campaignABTestWaitTime: 0.5,
        campaignABTestDecidingParameter: "",
        campaignABTestId: "",
        campaignABTestSubject: "",
        campaignABTestTemplateId: null,
      };
      state.wordpressFlag = false;
    },
    setCurrentABTestCampaign: (state, action) => {
      state.currentABTestCampaign = action.payload;
    },
  }
});

// Action creators are generated for each case reducer function
export const {
  setCategory,
  setwordpressFlag,
  setCampaignWidget,
  setCampaignIsAdvisor,
  setCampaignHtml,
  setCampaignId,
  setCampaignName,
  setCampaignDescription,
  setCampaignType,
  setCampaignSubject,
  setCampaignAudienceName,
  setCampaignAudienceId,
  setCampaignEmail,
  setcampaignEditMode,
  setCampignTemplateId,
  setCampaignFlow,
  setBackfromCampaign,
  setComplaiceStatus,
  setCampaignABTestEnabled,
  setCampaignABTestChecked,
  setCampaignABTestVariation,
  setCampaignABTestPercentage,
  setCampaignABTestWaitTime,
  setCampaignABTestSubject,
  setCampaignABTestId,
  setCampaignABTestTemplateId,
  setCurrentABTestCampaign,
  setCampaignABTestDecidingParameter,
  resetCampaignData,
  setisNewCampaignTempateId,
  setCampaignStatus,
  setIsLoading,
  setIsLoadingClone,
  setCampaignViewMode,
  setCC,
  setBCC,
  setPublishedUrl,
  setscriptCode,
} = campaignSlice.actions;

export default campaignSlice.reducer;
